import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-76e4e5c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-screen overflow-hidden flex flex-col gap-4" }
const _hoisted_2 = { class: "md:px-6 px-4" }
const _hoisted_3 = { class: "flex-1 flex border-t overflow-auto xl:overflow-hidden flex-col xl:flex-row pt-4 xl:pt-0" }
const _hoisted_4 = { class: "xl:hidden md:px-8 px-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "tabs",
  class: "sr-only"
}, "Select a tab", -1))
const _hoisted_6 = ["value", "selected"]
const _hoisted_7 = { class: "border-r w-[250px] min-h-screen bg-white hidden xl:block text-xs text-gray-600 font-medium" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "flex-1 md:p-8 p-4 xl:overflow-auto" }

import { ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/outline";
import type { Component } from "vue";
import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useTrackEvent } from "shared/composables/tracking";
import PageHeader from "@/components/layout/PageHeader.vue";
import Sidebar from "@/components/layout/Sidebar.vue";
import { useLoadCurrentProject } from "@/composables/project";
import TabDurations from "@/views/settings_project/components/TabDurations.vue";
import TabGeneral from "@/views/settings_project/components/TabGeneral.vue";
import TabParticipants from "@/views/settings_project/components/TabParticipants.vue";
import TabDailyReport from "./components/TabDailyReport.vue";

type Tab = {
  name: string;
  label: string;
  content: Component;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSettings',
  setup(__props) {

const { t } = useI18n();

const { project } = useLoadCurrentProject();
const trackEvent = useTrackEvent();

const tabs = computed(
  () =>
    [
      {
        name: "general",
        label: t("admin.project_settings.tab_general"),
        content: TabGeneral,
      },
      project.value?.features.includes("daily_report") && {
        name: "daily_report",
        label: t("admin.project_settings.tab_dcr"),
        content: TabDailyReport,
      },
      {
        name: "project_participants",
        label: t("admin.project_settings.tab_project_participants"),
        content: TabParticipants,
      },
      {
        name: "durations",
        label: t("admin.project_settings.tab_durations"),
        content: TabDurations,
      },
    ].filter((item) => item) as Tab[],
);

const router = useRouter();
const route = useRoute();

const currentTab = computed(() => {
  return tabs.value.find((tab) => tab.name === route.params.tab) || tabs.value[0];
});

const handleItemClick = (tab: string | Tab) => {
  const tabName = typeof tab === "string" ? tab : tab.name;
  router.push({
    name: "ProjectSettings",
    params: { ...route.params, tab: tabName }, // Ensure 'tab' is set here
  });
};

onMounted(() => {
  trackEvent("settings_view");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Sidebar, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PageHeader, null, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("app_features.project_settings")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("select", {
              id: "tabs",
              name: "tabs",
              class: "w-auto oai-inputs",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (handleItemClick(($event?.target as HTMLInputElement)?.value as string)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: tab.name,
                  value: tab.name,
                  selected: currentTab.value.name === tab.name
                }, _toDisplayString(tab.label), 9, _hoisted_6))
              }), 128))
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
              'px-5 md:px-8 py-2 lg:p-5 border-l-4 cursor-pointer hover:text-oaiGray-900 border-b text-gray-600 font-medium text-xs flex items-center justify-between break-words',
              currentTab.value === tab ? 'border-l-yellow text-oaiGray-900 bg-gray-50' : '',
            ]),
                key: tab.name,
                onClick: ($event: any) => (handleItemClick(tab))
              }, _toDisplayString(tab.label), 11, _hoisted_8))
            }), 128)),
            (_ctx.hasPermission('pct_admin'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "px-8 py-2 text-xs lg:p-5 cursor-pointer border-b border-l-4 font-medium flex items-center gap-1",
                  href: `https://pct.oculai.de/project-console?customer_name=${_ctx.currentCustomerName}&site_id=${_ctx.currentSiteId}`
                }, [
                  _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "w-4 h-4" }),
                  _createTextVNode(" Project Console ")
                ], 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(currentTab.value.content)))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})